export const styles = {
  title: {
    display: "flex",
    justifyContent: "space-between",
    mb: "2.5rem",
    flexDirection: "column",
  },
  container: {
    position: "relative",
    pt: "2.125rem",
    minHeight: "10rem",
  },
  eventAgendaAdd: {
    mt: "30px",
    display: "flex",
    ml: "auto",
    mr: "auto",
    svg: {
      height: "16px",
    },
  },
};
